
import VideoCard from "../components/VideoCard/VideoCard"
import { useEffect, useState } from "react";

const TutorialContainer = ({}) => {

    const [tutorials, setTutorials] = useState([]);
  
    useEffect(() => {
      fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/tutorial.json")
        .then((res) => res.json())
        .then((data) => setTutorials(data))
        .catch((err) => console.error("Error cargando bosses.json:", err));
    }, []);

  return (
    <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px", // espacio entre cartas
        width: "100%"}}>
        {tutorials.map((tuto) =>(
            <VideoCard 
                name={tuto.name}
                description={tuto.description}
                videoUrl={tuto.videoUrl}
                textFooter={tuto.textFooter}
                footerColor="#5e368fff"
            />
        ))
        }
    </div>
  )

}

export default TutorialContainer